import { NotificationReceiver } from './notification-receiver'

export interface NotificationUploadResponseInterface {
  /**
   * 表头信息
   */
  columns: string[]
  /**
   * 接收者变量
   */
  receivers: NotificationReceiver[]
}

export class NotificationUploadResponse
  implements NotificationUploadResponseInterface
{
  /**
   * 表头信息
   */
  columns: string[]
  /**
   * 接收者变量
   */
  receivers: NotificationReceiver[]

  constructor(props: NotificationUploadResponseInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      columns: _columns,
      receivers: _receivers,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.columns = _columns
    this.receivers = _receivers
      ? _receivers.map((i) => new NotificationReceiver(i))
      : _receivers
  }
}
